(function ($) {
	'use strict';

	// Ouverture de la modal au clic sur une classe
	// *******************************************************************************
	$('body').on('click', '.js-open-modal', function () {
		// Récupération de la modal à ouvrir
		const modal_id = $(this).attr('data-modal-id')
		const modal = $('.js-modal#' + modal_id)

		// on ouvre la modal
		openModal(modal)
	});

	// Fermeture de la modal au clic sur une classe
	// *******************************************************************************
	$('body').on('click', '.js-close-modal', function () {
		// Récupération de la modal à fermer
		const modal = $(this).parents('.js-modal')

		// on ferme la modal
		closeModal(modal)
	});

	// Fermeture de la modal au clic sur le body
	// *******************************************************************************
	$('body').on('click', function (event) {
    const modal = $('.js-modal.is-show');
    const clicked_element = $(event.target);

    // Vérifier si l'élément cliqué est à l'intérieur de la modal
    if (!clicked_element.closest('.modal-content').length) {
			// on ferme la modal
			closeModal(modal)
    }
	});

	// Ouverture de la modal
	// *******************************************************************************
	function openModal(modal) {
		// Affichage de la modal
		modal.show('fast', function() {
			// on fait l'animation qui fait apparaitre la modal
			modal.addClass('is-show')
		});
	}

	// Fermeture de la modal
	// *******************************************************************************
	function closeModal(modal) {
		// Si la modal existe
		if (modal.length) {
			// on fait l'animation qui fait disparaitre la modal
			modal.removeClass('is-show');

			// Cacher la modal une fois que l'animation css est ok
			modal.one('transitionend', function () {
				modal.hide();
			});
		}
	}

})(jQuery);
